//import timesheets from '../assets/data/timesheets'
import Vue from 'vue'
import axios from 'axios'
import * as _ from 'lodash';

export const STATUS_PENDING = 10;
export const STATUS_DISCARDED = 20;
export const STATUS_APPROVED = 30;

export const STATUS_PROGRESS_IN_WORK = 10;
export const STATUS_PROGRESS_SUBMITED = 20;
export const STATUS_PROGRESS_NOT_SUBMITED = 30;
export const STATUS_PROGRESS_PAY_APPROVED = 40;
export const STATUS_PROGRESS_TIME_APPROVED = 50;
export const STATUS_PROGRESS_DISCARDED = 60;
export const STATUS_PROGRESS_DISCARDED_BY_DRIVER = 70;

export default {
    state: {
        timesheets: [],
        timesheetforReports: [],
        period_date_from: void 0,
        period_date_to: void 0,
        invoice_last_id: void 0,
        invoice_intersection: void 0,
    },
    mutations: {
        fetchTimesheets(state, { payload, period_date_from, period_date_to}) {
            state.timesheets = payload;
            state.period_date_from = period_date_from;
            state.period_date_to = period_date_to;
        },
        fetchTimesheetforReports(state, { payload, period_date_from, period_date_to}) {
            state.timesheetforReports = payload;
            state.period_date_from = period_date_from;
            state.period_date_to = period_date_to;
        },
        fetchInvoiceCheck(state, payload) {
            state.invoice_last_id = payload.last_id;
            state.invoice_intersection = payload.invoices;
        },
        createNewTimesheet(state, payload) {
            // fix to prevent double insert(from http and Socket.io), check is time sheet already inserted (by this application instance)
            let timesheet = _.find(state.timesheets, p => p.id == payload.id);
            if (timesheet) {
                return; // exit
                //? or pass to update
            }

            // check is timesheet inserted in current date range
            if (state.period_date_from <= payload.period_date
                && state.period_date_to >= payload.period_date
            ) {
                state.timesheets.push(payload);
            }
        },
        removeTimesheet(state, payload) {
            for (let i = 0; i < state.timesheets.length; i++) {
                if (payload.id == state.timesheets[i].id) {
                    state.timesheets.splice(i, 1); // remove item
                    break; // founded exit
                }
            }
        },
        setTimesheets(state, payload) {
            state.timesheets = payload;
        },
        editTimesheet(state, payload) {
            const index = state.timesheets.findIndex(item => item.id === payload.id);
            Vue.set(state.timesheets, index, payload);
        },
        approveTimesheets(state, timesheets_payload) {
            for (let i = 0; i < timesheets_payload.length; i++) {
                let index = state.timesheets.findIndex(item => +item.id === +timesheets_payload[i].id);
                if (index === -1) {
                    state.timesheets.push(timesheets_payload[i]);
                } else {
                    Vue.set(state.timesheets, index, timesheets_payload[i]);
                }
            }
        },
    },

    actions: {
        async fetchTimesheets({ commit, dispatch }, {period_date_from, period_date_to, for_reports}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            let for_reports_param = '';
            if (for_reports == '1') {
                for_reports_param = '&for_reports=1';
            }
            try {
                let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/timesheet?period_date_from=${period_date_from}&period_date_to=${period_date_to}${for_reports_param}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                const mutation = for_reports == '1' ? 'fetchTimesheetforReports' : 'fetchTimesheets';
                commit(mutation, { payload: data, period_date_from, period_date_to });
            } catch(error) {
                commit('setLoading', false);
                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async createNewTimesheet({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/timesheet`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('createNewTimesheet', data)
                return data;
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async removeTimesheet({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.delete(`${this._vm.appConfig.app_url}/api/timesheet/${payload.id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('removeTimesheet', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async editTimesheet({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/timesheet/${payload.id}`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('editTimesheet', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

        async approveTimesheets({commit, dispatch}, timesheets) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let post_data = {
                    timesheets: timesheets
                };

                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/timesheet/approve`, post_data, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('approveTimesheets', data.result);
                return data; // return validation errors `data.fail`
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },

    },


    getters: {
        timesheets(state) {
            return state.timesheets
        },
        timesheets_period_date_from(state) {
            return state.period_date_from
        },
        timesheets_period_date_to(state) {
            return state.period_date_to
        },
        invoice_last_id(state) {
            return state.invoice_last_id;
        },
        invoice_intersection(state) {
            return state.invoice_intersection;
        }
    }
}
